import { FractalSDKContext } from "../../context/fractal-sdk-context.js";
import { useContext } from 'react';
export const useUserWallet = () => {
    const { userWallet } = useContext(FractalSDKContext);
    return { data: userWallet };
};
//# sourceMappingURL=use-user-wallet.js.map